import React from 'react'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import { Box, Button, Divider } from '@mui/material'
import { NavigateBefore } from '@mui/icons-material'
import { UserLogged } from '@/state/auth/models'

type Props = {
  activeStep: number
  loggedUser: UserLogged
  handleBack: () => void
  handleNext: () => void
  handleHideAction: () => void
  handleOnSubmit: () => void
}

const ActionsComponent = ({
  activeStep,
  loggedUser,
  handleBack,
  handleNext,
  handleHideAction,
  handleOnSubmit,
}: Props) => {
  const { t } = useTranslation()

  const [twoFactorCode] = useField('twoFactorCode')

  const isLastStep =
    activeStep === 1 || activeStep === 3 || loggedUser.twoFactorAuthActive

  return (
    <Box mt={3}>
      <Divider light />
      <Box display="flex" justifyContent="end" mt={2}>
        {!loggedUser.twoFactorAuthActive && activeStep === 2 ? (
          <Button
            className="margin-x"
            size="small"
            color="primary"
            startIcon={<NavigateBefore />}
            onClick={() => handleBack()}
          >
            {t('labels.back')}
          </Button>
        ) : activeStep !== 4 ? (
          <Button
            className="red"
            variant="contained"
            size="small"
            onClick={handleHideAction}
          >
            {t('labels.cancel')}
          </Button>
        ) : (
          <Button
            variant="contained"
            className="red"
            size="small"
            onClick={handleHideAction}
          >
            {t('labels.close')}
          </Button>
        )}
        {!loggedUser.twoFactorAuthActive && !isLastStep && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleNext()}
            sx={{ marginLeft: 2 }}
          >
            {t('labels.next')}
          </Button>
        )}
        {isLastStep && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleOnSubmit}
            disabled={twoFactorCode.value.length < 6}
            sx={{ marginLeft: 2 }}
          >
            {twoFactorCode.value.length < 6
              ? `${6 - twoFactorCode.value.length} ${t(
                  'twoFactor.twoFactorDigits',
                )}`
              : t('twoFactor.twoFactorVerify')}
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default ActionsComponent
